import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';
import { DetailsLayout, Text } from '../../common';

function DietDetails({ frequency, name, route, type, notes }) {
  const hasName = !isEmpty(name);
  const summary = `${type}${route ? ` by ${route}` : ''}`;
  const hasFrequency = !isEmpty(frequency);

  return (
    <DetailsLayout heading={`${type}`}>
      <Text>{summary}</Text>
      {hasFrequency && <Text>{frequency}</Text>}
      {hasName && <Text>Name of Formula: {name}</Text>}
      {notes && (
        <div>
          <Text>Notes: </Text>
          <Text>{notes}</Text>
        </div>
      )}
    </DetailsLayout>
  );
}

DietDetails.propTypes = {
  type: PropTypes.string.isRequired,
  frequency: PropTypes.string,
  name: PropTypes.string,
  notes: PropTypes.string,
  route: PropTypes.string,
};

DietDetails.defaultProps = {
  frequency: undefined,
  name: undefined,
  notes: undefined,
  route: undefined,
};

export default DietDetails;



// WEBPACK FOOTER //
// ./src/modules/DietPage/components/DietDetails.js